import Vue from 'vue';

const EventBus = new Vue();

const FOLLOWED_PRODUCT_IN_CURR_COLL = 'followedProductInCurrColl';
const DUPLICATED_PRODUCT_IN_CURR_COLL = 'duplicatedProductInCurrCol';
const EDITED_FOLLOWED_PRODUCT = 'editedFollowedProd';

export {
  EventBus,
  FOLLOWED_PRODUCT_IN_CURR_COLL,
  DUPLICATED_PRODUCT_IN_CURR_COLL,
  EDITED_FOLLOWED_PRODUCT,
};
